module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_1_0@2x.74cc7ae8.png";